import { cn, PaletteUtils } from '@shared/utils';
import CrownIcon from '@assets/icons/spinner/crown.svg';
import CrossIcon from '@assets/icons/spinner/cross.svg';
import style from './spinner.module.scss';

interface SpinnerProps {
  className?: string;
  show?: boolean;
  embedded?: boolean;
  position?: boolean;
  little?: boolean;
}

export const Spinner = (props: SpinnerProps) => {
  if (props.show === false) return null;

  const spinner = (
    <div
      className={cn(
        'relative flex h-[106px] w-[106px] justify-center',
        props.embedded && 'h-full w-full items-center',
        props.little && 'mx-10 mt-10 h-5 w-[80px] items-center',
      )}
    >
      <div
        className={cn(
          'relative h-[106px] w-[106px] rounded-full border-b-4 border-l-4 border-r-4 border-t-4 border-b-medium-gray border-r-medium-gray border-t-medium-gray',
          PaletteUtils.isInsigniaPalette && 'border-l-ecru',
          PaletteUtils.isVcfcPalette && 'border-l-primary',
          props.embedded && 'h-8 w-8 border-[3px]',
          props.little && 'h-[53px] w-[53px]',
          style.spinner,
        )}
      />
      <div className={cn('absolute flex h-full flex-col items-center justify-center', props.embedded && 'h-6 w-6')}>
        {PaletteUtils.isInsigniaPalette && <CrownIcon />}
        {PaletteUtils.isVcfcPalette && <CrossIcon width={80} height={80} />}
      </div>
    </div>
  );

  if (props.position)
    return (
      <div className={cn('fixed inset-0 z-[1200]', props.className)}>
        <div className='absolute inset-0 bg-white opacity-70 dark:bg-soft-black' />
        <div className='flex h-full items-center justify-center'>{spinner}</div>
      </div>
    );
  return (
    <div className={cn(props.className)}>
      <div className={cn('flex items-center justify-center', props.embedded && 'absolute left-0 top-0 h-full w-full bg-dark-ice-white')}>
        {spinner}
      </div>
    </div>
  );
};
